import * as React from "react";

import { IProductImage } from "~/graphql/queries/optionRemoderation/optionsPendingRemoderation";
import styled from "~/styled";

const ImageList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 180px);
  gap: 12px;
`;

const Image = styled.img`
  display: block;
  width: 180px;
`;

interface IProps {
  images: IProductImage[];
  onImageClick: (imageId: string, src: string) => void;
}

export default class AlternativeImagesList extends React.Component<IProps> {
  public render() {
    return (
      <ImageList>
        {this.props.images.map(
          image =>
            image.nextImage && (
              <Image
                key={image.id}
                src={image.nextImage.originalUrl + "?v=1"}
                onClick={this.handleClick(image)}
              />
            )
        )}
      </ImageList>
    );
  }

  private handleClick = (image: IProductImage) => (
    event: React.MouseEvent<HTMLImageElement>
  ) => {
    event.preventDefault();

    this.props.onImageClick(image.id, image.nextImage!.originalUrl);
  };
}



// WEBPACK FOOTER //
// ./src/components/Remoderation/AlternativeImagesList.tsx